import { render, staticRenderFns } from "./default.vue?vue&type=template&id=d1bc9c72&scoped=true"
import script from "./default.vue?vue&type=script&lang=ts"
export * from "./default.vue?vue&type=script&lang=ts"
import style0 from "./default.vue?vue&type=style&index=0&id=d1bc9c72&prod&lang=scss&scoped=true"
import style1 from "./default.vue?vue&type=style&index=1&id=d1bc9c72&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1bc9c72",
  null
  
)

export default component.exports